import { useState } from "react";

const MAX_TAGS = 20;

const normalize = (raw: string) => raw.trim().toLowerCase().replace(/^#+/, "").replace(/,/g, "").slice(0, 40);

/** Free tags as chips: Enter, comma or leaving the field adds; ✕ or Backspace removes. */
export default function TagInput({ tags, onChange }: { tags: string[]; onChange: (tags: string[]) => void }) {
  const [draft, setDraft] = useState("");

  const commit = (raw: string) => {
    const next = [...tags];
    for (const part of raw.split(",")) {
      const tag = normalize(part);
      if (tag && !next.includes(tag) && next.length < MAX_TAGS) next.push(tag);
    }
    if (next.length !== tags.length) onChange(next);
    setDraft("");
  };

  return (
    <div className="flex min-h-[52px] flex-wrap items-center gap-1.5 rounded-[14px] bg-white px-2.5 py-2 border border-line-soft shadow-card border-line focus-within:border-[#e39aa8] focus-within:ring-[3px] focus-within:ring-rose/20">
      {tags.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={() => onChange(tags.filter((t) => t !== tag))}
          aria-label={`Remove tag ${tag}`}
          className="flex items-center gap-1 rounded-full bg-lavender py-1 pl-3 pr-2 text-sm font-bold active:scale-95"
        >
          {tag}
          <span className="text-ink/40" aria-hidden>
            ✕
          </span>
        </button>
      ))}
      <input
        type="text"
        value={draft}
        onChange={(e) => (e.target.value.includes(",") ? commit(e.target.value) : setDraft(e.target.value))}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit(draft);
          } else if (e.key === "Backspace" && !draft && tags.length) {
            onChange(tags.slice(0, -1));
          }
        }}
        onBlur={() => draft && commit(draft)}
        placeholder={tags.length ? "Add tag…" : "Add tags — anything that helps you find it"}
        autoCapitalize="none"
        enterKeyHint="done"
        className="h-9 min-w-[8rem] flex-1 bg-transparent px-1.5 font-semibold outline-none placeholder:text-ink/40"
      />
    </div>
  );
}
